export default "__VITE_ASSET__ByQB9443__"